import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'currencySeparatorBD',
    standalone: false
})
export class CurrencySeparatorBDPipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): unknown {
    if (!Number.isNaN(parseFloat(value))) {
      return Intl.NumberFormat('en-IN').format(Math.round(parseFloat(value)));
    } else {
      return '';
    }
  }

}
